import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { DatabaseService } from "./database.service";
import { MotesPaths, Venue } from "../models";

@Injectable({ providedIn: 'root' })
export class VenueService {
    constructor(private db: DatabaseService) {
    }

    /**
    * Save a venue (predefined location) to the database
    */
    public saveVenue(venue: Venue): Promise<any> {
        if(!venue.key || !venue.projectKey) {
            console.warn("Could not create venue, no key or projectKey");
            return;
        }

        if(!venue.createdOn) {
            venue.createdOn = this.db.serverTime();
        }
        // Create database reference and update moteContent
        return this.db.database.ref(MotesPaths.VENUE_DB_PATH(venue.key)).update(venue.toJson());
    }

    /**
     * Delete a venue
     */
    public async deleteVenue(venueKey: string): Promise<boolean> {
        if(!venueKey) return false;
        return this.db.database.ref(MotesPaths.VENUE_DB_PATH(venueKey)).remove().then(() => true).catch(() => false);
    }

    /**
    * Watch all venues (predefined location) of a project
    */
    public watchProjectVenues(projectKey: string): Observable<Venue[]> {
        // Get all vouchers belonging to this product
        let query = (ref) => ref.orderByChild('projectKey').equalTo(projectKey);

        return this.db.database.list(MotesPaths.VENUE_DB_PATH(), query).snapshotChanges().pipe(map(snapList => {
            // Get payload json from firebase and create venue objects
            return snapList.map((snap) => new Venue(snap.payload.val(), snap.key));
        }));
    }
}
